import React from 'react';
import AddHealthCenter from '../components/AddHealthCenter';

const NewHealthCenter: React.FC = () => {
  return (
    <div>
        <AddHealthCenter />
    </div>
  );
};

export default NewHealthCenter;